'use strict';

var tslib = require('tslib');
var React = require('react');
var dropzone = require('@alfalab/core-components/dropzone');
var bemReactClassname = require('bem-react-classname');
var core_backgroundPlate_types = require('../../types.js');
var core_backgroundPlate_components_overlay_overlay = require('../overlay/overlay.js');
require('./background-plate.css');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var checkIsDropzone = function (view) { return (view === core_backgroundPlate_types.BackgroundPlateView.Dropzone
    ||
        view === core_backgroundPlate_types.BackgroundPlateView.DropzoneSecondary); };
var BackgroundPlate = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var divAttributes = _a.divAttributes, dropzoneProps = _a.dropzoneProps, children = _a.children, dataTestId = _a["data-test-id"], className = _a.className, hasHover = _a.hasHover, isInner = _a.isInner, showInnerPlate = _a.showInnerPlate, view = _a.view;
    var cn = bemReactClassname.createCn('background-plate', className);
    var isDropzone = checkIsDropzone(view);
    var classNames = isInner ?
        cn((_b = {
                inner: true
            },
            _b[view] = true,
            _b.clickable = hasHover,
            _b['without-error'] = !(dropzoneProps === null || dropzoneProps === void 0 ? void 0 : dropzoneProps.error),
            _b))
        : cn((_c = {},
            _c[view || core_backgroundPlate_types.BackgroundPlateView.Primary] = true,
            _c.clickable = hasHover && !showInnerPlate,
            _c.padding = showInnerPlate,
            _c['without-error'] = !(dropzoneProps === null || dropzoneProps === void 0 ? void 0 : dropzoneProps.error),
            _c));
    return (isDropzone ? (React__default.default.createElement(dropzone.Dropzone, tslib.__assign({ className: classNames, "data-test-id": dataTestId, block: true, 
        /* eslint-disable-next-line */
        Overlay: function (props) { return (React__default.default.createElement(core_backgroundPlate_components_overlay_overlay.Overlay, tslib.__assign({}, props, { error: dropzoneProps === null || dropzoneProps === void 0 ? void 0 : dropzoneProps.error, view: view, isInner: isInner }))); } }, dropzoneProps), children)) : (React__default.default.createElement("div", tslib.__assign({ className: classNames, "data-test-id": dataTestId, ref: ref }, divAttributes), children)));
});

exports.BackgroundPlate = BackgroundPlate;
